import useGlobalStore from 'store/global';
import { useFinancialYearStore } from 'store';

const useCompanyPreferences = () => {
  const { companyPreferences, setCompanyPreferences, clearGlobalState } = useGlobalStore();
  const currentFinancialYear = useFinancialYearStore((state) => state.currentFinancialYear);

  // Helper method to check if a feature is enabled
  const isFeatureEnabled = (feature) => {
    if (!companyPreferences) return false;
    return companyPreferences[feature] === 1;
  };

  // Specific feature checks
  const isShapeEnabled = () => isFeatureEnabled('shp');
  const isColorEnabled = () => isFeatureEnabled('clt');
  const isSizeEnabled = () => isFeatureEnabled('sz');
  const isPackRatioEnabled = () => isFeatureEnabled('packratio');
  const isLotEnabled = () => isFeatureEnabled('lot');
  const isDocUploaderEnabled = () => isFeatureEnabled('docuploader');
  const isMsgEnabled = () => isFeatureEnabled('msg');
  const isSchemeOrderEnabled = () => isFeatureEnabled('allow_scheme_order');
  const isForeignExportEnabled = () => isFeatureEnabled('foreign_export');
  const isTraderSalebillAutoNumberEnabled = () =>
    isFeatureEnabled('trader_salebill_auto_number');
  const isOrderEntryEnabled = () => {
    if (!currentFinancialYear) return true;
    return currentFinancialYear.man_aut !== 0;
  };

  // 0 = Default only, 1 = Without Items only, 2 = Both
  const getSalebillMode = () => {
    if (!companyPreferences) return 2;
    return companyPreferences.salebill_mode ?? 2;
  };

  return {
    // Company preferences data
    companyPreferences,
    
    // Actions
    setCompanyPreferences,
    clearGlobalState,
    
    // Helper functions
    isFeatureEnabled,
    isShapeEnabled,
    isColorEnabled,
    isSizeEnabled,
    isPackRatioEnabled,
    isLotEnabled,
    isDocUploaderEnabled,
    isMsgEnabled,
    isSchemeOrderEnabled,
    isForeignExportEnabled,
    isTraderSalebillAutoNumberEnabled,
    isOrderEntryEnabled,
    getSalebillMode,
  };
};

export default useCompanyPreferences; 